import { Component } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { PackagesFlowService } from "app/services/packages-flow.service";
import { PackageDataModel } from "app/models/package.model";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { PaymentIntentStatus } from "app/models/payment-intent.model";
import { SvgIconComponent } from "app/modules/shared/svg-icon/svg-icon.component";

@Component({
  selector: "app-package-status",
  imports: [TranslateModule, SvgIconComponent],
  templateUrl: "./package-status.component.html",
  styleUrls: ["./package-status.component.scss"],
})
export class PackageStatusComponent {
  constructor(
    public packagesFlowService: PackagesFlowService,
    private router: Router,
    private translationService: TranslateService,
  ) {}

  get PaymentIntentStatus(): typeof PaymentIntentStatus {
    return PaymentIntentStatus;
  }

  retryPayment(packageData: PackageDataModel) {
    this.packagesFlowService.retryPayment(packageData);
  }

  navigateToContactPage() {
    this.translationService.get("links.Misc_contact").subscribe((res) => {
      this.router.navigate([res]);
    });
  }
}
